// Preferred tee-time windows (hourly bands) — the single source of truth for
// the reseller/customer "request-mode" course flow. Kept in lock-step with the
// backend list in tournament-api/src/controllers/customTripRequestController.js
// (TIME_WINDOWS). A non-integration course isn't booked live, so instead of a
// real tee time the customer/reseller picks a one-hour window; the round is
// parked as 'awaiting_confirmation' and confirmed by hand.
//
// value: 'HH:MM-HH:MM' (24h, stored on the round's TeeTime as `~${value}` so the
//        backend's `startsWith('~')` manual check still fires — see
//        resellerQuotesController isManual).
// label: human-friendly 12h band, e.g. '8:00 AM – 9:00 AM'.
export const TIME_WINDOWS = ['06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00'].map(start => {
  const h = Number(start.slice(0, 2))
  const end = String(h + 1).padStart(2, '0') + ':00'
  const fmt = (hh) => { const ap = hh >= 12 ? 'PM' : 'AM'; const hr = hh % 12 || 12; return `${hr}:00 ${ap}` }
  return { value: `${start}-${end}`, label: `${fmt(h)} – ${fmt(h + 1)}` }
})

// Given a stored TeeTime (possibly `~08:00-09:00`, or a bare `08:00-09:00`, or a
// legacy `~09:30`), return the matching window value if it is one of our bands,
// else null. Lets the picker re-select the saved window on reopen.
export function windowValueOf(teeTime) {
  if (!teeTime) return null
  const raw = String(teeTime).replace(/^~/, '')
  return TIME_WINDOWS.some(w => w.value === raw) ? raw : null
}
